import { Box, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";

import { RegistrationChoice } from "@/components/registration/RegistrationChoice";
import { layoutTokens } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    "& > button[role=checkbox]": {
      padding: theme.spacing(2),
      gap: theme.spacing(1.5),
      border: 0,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.5,
      color: theme.palette.text.primary,
      "& > span[aria-hidden=true]": {
        border: 0,
        boxShadow: `inset 0 0 0 1.5px ${theme.palette.semantic["border/strong"]}`,
      },
      "&[aria-checked=true]": {
        boxShadow: `inset 0 0 0 1.5px ${theme.palette.primary.main}`,
        "& > span[aria-hidden=true]": { boxShadow: "none" },
      },
      [theme.breakpoints.up("md")]: { fontSize: 16 },
    },
  },
  notice: {
    padding: theme.spacing(2),
    borderRadius: layoutTokens.radius.md,
    backgroundColor: theme.palette.semantic["accent/bg"],
    [theme.breakpoints.up("md")]: { backgroundColor: theme.palette.semantic["status/info-bg"] },
  },
  main: { display: "flex", flexDirection: "column", gap: theme.spacing(1) },
  heading: {
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    [theme.breakpoints.up("md")]: { fontSize: 16 },
  },
  body: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
    whiteSpace: "pre-line",
    overflowWrap: "anywhere",
    color: theme.palette.text.secondary,
    [theme.breakpoints.up("md")]: { fontSize: 14 },
  },
  privacy: { marginTop: theme.spacing(1.5), display: "flex", flexDirection: "column", gap: theme.spacing(0.5) },
}));

/** 注意書きのある利用目的は、選択したカードの直下に案内を表示する。 */
export const RegistrationReasonChoice = React.forwardRef<
  HTMLButtonElement,
  {
    label: string;
    checked: boolean;
    onChange: () => void;
    onBlur?: () => void;
    helperText?: string;
    noticeTitle?: string;
    info?: string;
    error?: boolean;
  }
>(({ label, checked, onChange, onBlur, helperText, noticeTitle, info, error }, ref) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <RegistrationChoice
        ref={ref}
        list
        error={error}
        label={label}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
      />
      {checked && helperText && (
        <Box
          component="aside"
          className={classes.notice}
          aria-label={`${label}のご案内`}
          data-registration-purpose-notice
        >
          <Box className={classes.main}>
            <Typography component="h2" className={classes.heading}>{noticeTitle}</Typography>
            <Typography className={classes.body}>{helperText}</Typography>
          </Box>
          {info && (
            <Box className={classes.privacy}>
              <Typography component="h3" className={classes.heading}>個人情報の取り扱い</Typography>
              <Typography className={classes.body}>{info}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
});

RegistrationReasonChoice.displayName = "RegistrationReasonChoice";
